<template>
    <div>
        <navigation :cate="cate" @keywordSearch="keywordSearch" @assignWork="assignWork" @courseChange="courseChange">
            <select-date :type="4" :course_id="form.course_id" @change-date="dateChange"></select-date>
        </navigation>
        <housework-list v-if="list.length > 0" :list="list"></housework-list>
        <el-empty v-else description="暂无数据"></el-empty>
        <assign-homework v-if="show" :show="show" @close="close" @updateHousework="updateHousework"></assign-homework>
        <el-pagination class="page" background layout="prev, pager, next" hide-on-single-page :page-size="form.perPage"
            :current-page="form.page" @current-change="currentPage" :total="total">
        </el-pagination>
    </div>
</template>

<script>
import Navigation from './components/list/Navigation.vue'
import HouseworkList from './components/list/HouseworkList.vue'
import AssignHomework from './components/list/AssignHomework.vue'
import SelectDate from '../../../components/filterComponent/SelectDate.vue'
import { mapState } from 'vuex'
export default {
    components: { Navigation, HouseworkList, AssignHomework, SelectDate },
    name: 'Housework',
    data () {
        return {
            form: {
                class_id: localStorage.getItem('class_id'),
                date: '',
                keyword: '',
                course_id: this.$store.state.classInfo.course_id,
                page: 1,
                perPage: 12,
            },
            list: [], //作业列表
            total: 0, // 作业总条数
            show: false, // 是否显示布置作业弹窗
            cate: localStorage.getItem('cate'), //角色分类
        }
    },
    watch: {
        'classInfo.id' (val, oldVal) {
            console.log(val, oldVal)
            // if (val !== oldVal) {
            this.form.class_id = val
            this.form.page = 1
            this.form.course_id = this.classInfo.course_id
            this.getHouseworkList()
            // }
        },
        housework_status (val, oldVal) {
            if (val) {
                this.getHouseworkList()
                this.$store.dispatch('setHouseworkStatus', false)
            }
        }
    },
    computed: {
        ...mapState({
            class_id: state => state.class_id,
            classInfo: state => state.classInfo,
            housework_status: state => state.housework_status
        }),
    },
    mounted () {
        this.getHouseworkList()
        // this.$store.dispatch('setHouseworkStatus', false)
    },
    // 路由守卫
    beforeRouteLeave (to, from, next) {
        if (to.meta.activeMenu !== '/housework') {//此处判断是如果返回上一层，你可以根据自己的业务更改此处的判断逻辑，酌情决定是否摧毁本层缓存。   
            if (this.$vnode && this.$vnode.data.keepAlive) {
                if (this.$vnode.parent && this.$vnode.parent.componentInstance && this.$vnode.parent.componentInstance.cache) {
                    if (this.$vnode.componentOptions) {
                        var key = this.$vnode.key == null
                            ? this.$vnode.componentOptions.Ctor.cid + (this.$vnode.componentOptions.tag ? `::${this.$vnode.componentOptions.tag}` : '')
                            : this.$vnode.key
                        var cache = this.$vnode.parent.componentInstance.cache
                        var keys = this.$vnode.parent.componentInstance.keys
                        if (cache[key]) {
                            if (keys.length) {
                                var index = keys.indexOf(key)
                                if (index > -1) {
                                    keys.splice(index, 1)
                                }
                            }
                            delete cache[key]
                        }
                    }
                }
            }
            this.$destroy()
        }
        next()

    },
    methods: {
        // 获取作业列表
        async getHouseworkList () {
            const { data: res } = await this.$axios.post('/base/homework/list', this.form)
            if (res.errCode === 0) {
                this.list = res.data
                this.total = res.meta.pagination.total
            }
        },
        keywordSearch (keyword) {
            this.form.keyword = keyword
            this.form.page = 1
            this.getHouseworkList()
        },
        dateChange (date) {
            this.form.date = date
            this.form.page = 1
            this.getHouseworkList()
        },
        currentPage (val) {
            this.form.page = val
            this.getHouseworkList()
        },
        courseChange (val) {
            this.form.course_id = val
            this.form.page = 1
            this.getHouseworkList()
        },
        // 打开布置作业弹窗
        assignWork () {
            this.show = true
        },
        // 关闭作业布置弹窗
        close () {
            this.show = false
        },
        // 布置作业完成，更新作业
        updateHousework () {
            this.show = false
            this.getHouseworkList()
        }
    },

}
</script>

<style lang="scss" scoped>
.page {
    margin-top: 40px;
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/view/Panel/housework/index.vue